import WrapAuthContext from "./contexts/auth/WrapAuthContext";
import AppRouter from "./router/AppRouter";
import WrapMantine from "./wrappers/mantine/WrapMantine";
import WrapQRCodeContext from "./contexts/qr-code/WrapQRCodeContext";
import WrapFolderContext from "./contexts/folder/WrapFolderContext";
import WrapDialogsContexts from "./components/dialogs/WrapDialogsContexts";
import DialogsContainer from "./components/dialogs/DialogsContainer";
import WrapQRCodeIconContext from "./contexts/qr-code/icon/WrapQRCodeIconContext";
import WrapQRCodeStyleContext from "./contexts/qr-code/style/WrapQRCodeStyleContext";

type AppProps = {}

/**
 * Entire application component.
 * It wraps router inside a contexts, themes and others.
 * @param _
 * @constructor
 * @author Kacper Faber
 * @since 0.1.0
 */
function App(_: AppProps) {
    return (
        <WrapMantine>
            <WrapAuthContext> { /* Auth context - to hold current user. */}
                <WrapQRCodeContext mustBeAuthenticated={true}>
                    <WrapQRCodeStyleContext>
                        <WrapQRCodeIconContext>
                            <WrapFolderContext>
                                <WrapDialogsContexts>
                                    <DialogsContainer/>

                                    <AppRouter/>
                                </WrapDialogsContexts>
                            </WrapFolderContext>
                        </WrapQRCodeIconContext>
                    </WrapQRCodeStyleContext>
                </WrapQRCodeContext>
            </WrapAuthContext>
        </WrapMantine>
    );
}

export default App;